import { render } from "./SliderPersons.vue?vue&type=template&id=5d2430f8&ts=true&lang=pug"
import script from "./SliderPersons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderPersons.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__